/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkPalAuthSubmissionAsManualRequest
 */
export interface MarkPalAuthSubmissionAsManualRequest {
    /**
     * Optional comment explaining the manual submission
     * @type {string}
     * @memberof MarkPalAuthSubmissionAsManualRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the MarkPalAuthSubmissionAsManualRequest interface.
 */
export function instanceOfMarkPalAuthSubmissionAsManualRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MarkPalAuthSubmissionAsManualRequestFromJSON(json: any): MarkPalAuthSubmissionAsManualRequest {
    return MarkPalAuthSubmissionAsManualRequestFromJSONTyped(json, false);
}

export function MarkPalAuthSubmissionAsManualRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkPalAuthSubmissionAsManualRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function MarkPalAuthSubmissionAsManualRequestToJSON(value?: MarkPalAuthSubmissionAsManualRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
    };
}

